<template>
  <div v-if="!complete">
    <div v-if="!user.id" class="top">
      <div class="top-nickname">
        <input placeholder="请输入本人昵称，谨防诈骗❗️" class="top-nickname-input" v-model="username" id="input-name" />
        <p class="top-nickname-tips">{{ tips }}</p>
      </div>
      <button class="top-button" @click="usernameClick(false)">确认</button>
    </div>
    <div v-else>
      <div class="top">
        <div class="user">
          <img :src="user.avatar + 'thumb'" class="user-avatar" />
          <div class="user-detail">
            <p class="user-nickname">{{ user.nickname }}</p>
            <span class="user-level" v-if="user.wealth > 0">
              <span class="user-level-icon"></span>
              {{ user.wealth }}
            </span>
          </div>
          <button class="user-switch" @click="clearUser">切换</button>
        </div>
      </div>
      <div style="text-align: left;padding-left: 20px;background: #fff;padding: 10px 16px;color: #666;">请确认是否为本人的昵称头像</div>
    </div>
    <div style="background: #f7f6fb; text-align: left">
      <div style="background: #f7f6fb; border-radius: 4px; padding: 20px">
        <div>
          <strong>请选择充值钻石</strong><br />
          <span style="color: #999999; font-size: 12px">(1元=10钻)</span>
        </div>
        <div class="coin-container">
          <template v-for="(item, index) in charge">
            <div :class="[
    select == index ? 'coin-item-selected' : '',
    item.price > 0 ? 'coin-item' : 'coin-item-custom',
  ]" v-on:click="itemClick(index)" :key="item.id">
              <div class="coin-item-1">
                <template v-if="item.price > 0">
                  <span class="coin-icon"></span>
                  <div class="coin-item-2">
                    <div class="coin-item-name" :class="select == index ? 'coin-item-name-selected' : ''">
                      {{ item.name }}
                    </div>
                    <div class="coin-item-price" :class="select == index ? 'coin-item-name-selected' : ''">
                      ¥{{ item.price / 100 }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="coin-item-2">
                    <span v-if="other > 0" style="
                        color: #222222;
                        font-weight: 500;
                        font-size: 20px;
                        margin-top: 2px;
                      ">¥</span>
                    <input type="number" class="input-custom" placeholder="请输入其他金额" v-model.number="other"
                      oninput="value=value.replace(/[^0-9]/g,'')" />
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div style="font-weight: 500; margin-top: 15px">请选择支付方式</div>
        <div>
          <div class="pay-m-c" style="padding: 15px 0px" @click="client = 'wechat'">
            <div class="pay-m-c">
              <img src="../assets/par_wachat.png" style="width: 22px; margin-right: 10px" />
              <div style="flex: 1">微信支付</div>
            </div>
            <img v-if="client == 'wechat'" src="../assets/recharge_check_s.png"
              style="width: 22px; margin-right: 10px" />
            <img v-else src="../assets/recharge_check_n.png" style="width: 22px; margin-right: 10px" />
          </div>
          <!-- <div>无法拉起微信时，可复制当前链接在浏览器中打开</div> -->
          <div class="pay-m-c" @click="client = 'alipay'">
            <div class="pay-m-c">
              <img src="../assets/par_zhifubao.png" style="width: 22px; margin-right: 10px" />
              <div style="flex: 1">支付宝支付</div>
            </div>
            <img v-if="client == 'alipay'" src="../assets/recharge_check_s.png"
              style="width: 22px; margin-right: 10px" />
            <img v-else src="../assets/recharge_check_n.png" style="width: 22px; margin-right: 10px" />
          </div>
        </div>
        <button class="icon-buy-btn" :disabled="!rmb > 0 || !user.id" @click="payClick">
          立刻购买
        </button>
      </div>
    </div>

    <div style="
        color: #999999;
        text-align: left;
        margin-left: 10px;
        margin-top: 10px;
      ">
      <p> 请注意：充值成功后，无法退款</p>
      <p>微信支付若提示“商家参数格式有误”，请刷新当面页面或开启无痕浏览即可解决</p>
    </div>
    <!-- <input
      placeholder="充值其他金额"
      v-model.number="other"
      :charge="rmb>0"
      @click="select=-1"
      class="charge-other"
    />-->

    <div class="bottom" style="display: none">
      <div class="bottom-text">
        <p class="bottom-text-1">
          支付：
          <span style="color: #f109f3">¥{{ rmb || 0 }}</span>
        </p>
        <p class="bottom-text-2">获得{{ gold || 0 }}颗钻石</p>
      </div>
      <button class="bottom-button" :disabled="!rmb > 0 || !user.id" @click="payClick">
        购买
      </button>
    </div>

    <div class="alipay-copy" v-if="alipay_url">
      <p>请复制以下文本到浏览器中打开</p>
      <p style="width: 100%; font-size: 10px; word-wrap: break-word">
        {{ alipay_url }}
      </p>
    </div>

    <div class="toast" v-if="show_toast">{{ toast_text }}</div>
  </div>
  <div v-else>
    <div class="complete">
      <img class="complete-icon" src="../assets/recharge_complete.png" />
      <p style="color: #181818; font-size: 20px; font-weight: 500; margin: 0">
        充值成功
      </p>
    </div>
    <div class="complete-container">
      <p class="complete-text">
        <span style="color: #999999">用户名</span>
        <span style="color: #181818">{{ user.nickname }}</span>
      </p>
      <p class="complete-text">
        <span style="color: #999999">充值数量</span>
        <span style="color: #181818">{{ gold }}钻</span>
      </p>
    </div>
    <!-- <button class="button-exit" @click="window.opener=null;window.close()">退出</button> -->
    <button class="button-continue" @click="complete = !complete">
      继续充值
    </button>
  </div>
</template>



<script>
import request from "../request.js";

// let host = "http://sm-debug.taowoapp.com";
// let host = "https://sm.appwuhui.com";
export default {
  name: "HelloWorld",
  data() {
    return {
      select: 0,
      other: "",
      tips: "",
      complete: false,
      charge: [],
      username: "",
      user: {
        id: 0,
        nickname: "",
        avatar: "",
        wealth: 0,
      },
      client: "wechat",
      alipay_url: "",
      isWeixin:
        navigator.userAgent.toLowerCase().indexOf("micromessenger") != -1,
      show_toast: false,
      toast_text: "",
    };
  },
  created() {
    var name = this.getUrlParam("name");
    this.sm_sign = this.getUrlParam("s") || "null";

    // 接收从客户端传来的name
    if (name) {
      this.username = decodeURIComponent(name);
      this.usernameClick(true);
    }
    if (this.isWeixin && !window.location.search.match(/open_id=/i)) {
      this.axios
        .get(
          `https://api.taowoapp.com/api/wechat/login/?url=${window.location.href}`
        )
        .then((response) => {
          window.location.href = response.data.data.url;
        });
    }
  },
  mounted() {
    if (!this.isWeixin) {
      this.client = "alipay";
    }
    request.get(`/api/payment/web_products/`).then((response) => {
      let data = response.data;
      for (var j = 0; j < data.list.length; j++) {
        var item = data.list[j];
        if (item.selected) {
          this.select = j;
          break;
        }
      }
      this.charge = data.list;
    });
  },
  computed: {
    gold() {
      if (this.charge[this.select]) {
        let coinCount = this.charge[this.select].coin_count;
        if (coinCount && coinCount > 0) {
          return coinCount;
        } else {
          return this.other * 10;
        }
      } else {
        return 0;
      }
    },
    rmb() {
      if (this.charge[this.select]) {
        let price = this.charge[this.select].price;
        if (price && price > 0) {
          return price / 100;
        } else {
          return this.other;
        }
      } else {
        return 0;
      }
    },
  },
  methods: {
    itemClick(index) {
      this.select = index;
      let select = this.charge[index];
      if (select.price > 0) {
        this.other = "";
      }
    },
    showTip(tip) {
      if (tip && tip.length > 0) {
        this.toast_text = tip;
        this.show_toast = true;
        setTimeout(() => {
          this.show_toast = false;
        }, 3000);
      }
    },
    payClick() {
      let select = this.charge[this.select];
      var price = select.price;
      if (price <= 0) {
        if (parseInt(this.other) < 0) {
          this.showTip("请输入大于0的整数");
          return;
        } else {
          price = this.other * 100;
        }
      }
      let client = "h5";
      if (this.isWeixin) {
        client = this.client == "wechat" ? "js" : "h5";
      }

      var returnUrl = window.location.origin + window.location.pathname;
      var name = this.username;
      if (name) {
        returnUrl = returnUrl + "?name=" + encodeURIComponent(name);
      }

      request.post(`/api/payment/web_pay/`, {
          user_id: this.user.id,
          price: price,
          product_id: select.id,
          platform: client,
          return_url: returnUrl,
          quit_url: "",
          client: this.client,
          open_id: this.getUrlParam("open_id") || "",
          special: this.getUrlParam("special") || "",
          live_id: this.getUrlParam("live_id") || "",
        })
        .then((response) => {
          let data = response.data;
          if (this.client == "wechat" && this.isWeixin) {
            this.onBridgeReady(data.url);
          } else {
            // eslint-disable-next-line no-console
            if (this.isWeixin) {
              this.alipay_url = data.url;
            } else {
              window.location.href = data.url;
            }
          }
        })
        .catch((e) => {
          if (e.response.data.message) {
            this.showTip(e.response.data.message);
          } else {
            alert(e);
          }
        });
    },
    usernameClick(isAuto) {
      var params = {
        nickname: this.username,
      }
      if (isAuto) {
        params.s = this.sm_sign
      }
      request
        .post(`/api/payment/verify_web_user/`, params)
        .then((response) => {
          let data = response.data;
          Object.assign(this.user, data);
          for (var item of data.badges) {
            if (item.startsWith("wealth_")) {
              this.user.wealth = item.match(/wealth_(\d+)/i)[1];
            }
          }
        })
        .catch((err) => {
          console.log(err)
          if (err.response.status == 404) {
            if (!isAuto) {
              this.showTip("该用户不存在");
            } else {
              this.username = ""
            }
          } else if (err.response.data.message) {
            this.showTip(err.response.data.message);
          } else {
            alert(err);
          }
        });
    },
    clearUser() {
      this.user = {
        id: 0,
        nickname: "",
        avatar: "",
        wealth: 0,
      };
      this.username = "";
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    onBridgeReady(data) {
      if (typeof WeixinJSBridge == "undefined") {
        return;
      }
      // eslint-disable-next-line no-console
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.complete = true;
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            // eslint-disable-next-line no-console
            console.log("用户取消");
          } else if (res.err_msg == "get_brand_wcpay_request:fail") {
            // eslint-disable-next-line no-console
            console.log("支付失败");
          } else {
            alert("充值失败请稍后重试");
            // eslint-disable-next-line no-console
            console.log("反正失败了" + res.err_msg);
          }
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.coin-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
}

.coin-item {
  flex: 1;
  background: white;
  border-radius: 2px;
  width: 40%;
  min-width: 40%;
  max-width: 40%;
  margin-right: 9px;
  margin-top: 15px;
  padding: 10px;
  font-size: 13px;
  font-family: 500;
}

.coin-item-selected {
  background: #e3ebff;
  border: 1px solid #f109f3;
}

.coin-item-name-selected {
  color: #f109f3 !important;
}

.coin-icon {
  background: url("../assets/_recharge_diamond.png");
  width: 19px;
  height: 16px;
  background-size: 100%;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
}

.coin-item-1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.coin-item-2 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.coin-item-name {
  color: #212121;
  font-weight: 500;
  margin-left: 1px;
}

.coin-item-price {
  color: #a5a5a5;
}

.coin-item-custom {
  flex: 1;
  background: white;
  border-radius: 2px;
  width: 80%;
  min-width: 40%;
  max-width: 100%;
  margin-right: 9px;
  margin-top: 15px;
  padding: 0 10px;
  font-size: 13px;
  font-family: 500;
}

.input-custom {
  border: 0;
  background: none;
  width: 100%;
  height: 35px;
  padding: 0;
  margin: 0;
  margin-left: 5px;
  outline: none;
  font-size: 20px;
  font-weight: 500;
  color: #222222;
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #a5a5a5;
  font-size: 14px;
}

:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #a5a5a5;
  font-size: 14px;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a5a5a5;
  font-size: 14px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #a5a5a5;
  font-size: 14px;
}

.toast {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  z-index: 99;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px 8px 8px 8px;
  padding: 10px 15px;
  color: white;
}

.pay-m-c {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.icon-buy-btn {
  margin: 20px auto;
  height: 42px;
  width: 100%;
  line-height: 42px;
  background: #f109f3;
  border-radius: 2px;
  color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 500;

  &[disabled] {
    background: #d5d5d5;
  }
}

.top {
  height: 72px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  &-nickname {
    position: relative;
    width: 100%;

    &-input {
      font-size: 14px;
      color: rgba(24, 24, 24, 1);
      line-height: 14px;
      outline: none;
      border: none;
    }

    &-tips {
      position: absolute;
      left: 3px;
      font-size: 12px;
      color: rgba(240, 48, 78, 1);
      line-height: 12px;
      margin: 0;
    }
  }

  &-button {
    background: #f109f3;
    outline: none;
    height: 32px;
    width: 66px;
    font-size: 14px;
    color: #ffffff;
    margin: 0;
    padding: 0;
    border-radius: 1px;
    border: 0;
  }

  .user {
    display: flex;
    align-items: center;
    width: 100%;

    &-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      display: inline-block;
    }

    &-detail {
      margin-left: 10px;
      text-align: left;
    }

    &-nickname {
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      margin: 0;
    }

    &-level {
      text-align: left;
      font-size: 9px;
      line-height: 9px;
      margin: 0;
      padding: 2px;
      background: linear-gradient(90deg,
          rgba(255, 170, 43, 1) 0%,
          rgba(253, 189, 32, 1) 100%);
      border-radius: 2px;
      display: inline-block;
      color: #f7f7ff;

      &-icon {
        background: url("../assets/data_recharge_diamond.png");
        width: 11px;
        height: 10px;
        background-size: 100%;
        display: inline-block;
        vertical-align: middle;
      }
    }

    &-switch {
      display: inline-block;
      padding: 9px 18px;
      background: white;
      border-radius: 2px;
      border: 1px solid #efefef;
      margin-left: auto;
      color: #222222 !important;
    }
  }
}

.charge {
  background: white;
  margin: 10px 0;
  padding: 0;
  padding-left: 15px;

  &-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    text-align: left;
    height: 48px;
    border-bottom: 1px solid #ededed;

    &-icon {
      background: url("../assets/_recharge_diamond.png");
      background-size: 100%;
      width: 18px;
      height: 17px;
      margin-right: 12px;
    }

    &-gold {
      font-style: normal;
      white-space: pre;
      color: #f109f3;
    }

    &-select {
      margin-left: auto;
      margin-right: 15px;
      color: #f109f3;
    }
  }

  &-other {
    box-sizing: border-box;
    width: 100%;
    line-height: 48px;
    font-size: 14px;
    text-align: center;
    outline: none;

    &::placeholder {
      text-align: center;
    }
  }
}

.client-select {
  margin-bottom: 70px;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  padding: 5px 20px;
  font-size: 14px;

  &-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    background: rgba(31, 31, 47, 0.2);
    border-radius: 4px;
  }

  &-alipay {
    background: rgba(3, 161, 233, 1);
  }

  &-wechat {
    background: rgba(55, 211, 50, 1);
  }
}

// .icon{
//   &-alipay{
//     height:40px;
//     width:40px;
//     display:block;
//   }
//   &-wechat{
//     height:40px;
//     width:40px;
//     display:block;
//   }
// }
.bottom {
  position: fixed;
  bottom: 0;
  height: 58px;
  width: 100%;
  background: white;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  padding: 12px 15px;

  &-text {
    min-width: 96px;
    text-align: left;

    &-1 {
      font-size: 16px;
      line-height: 16px;
      margin: 0;
    }

    &-2 {
      font-size: 12px;
      line-height: 12px;
      margin: 6px 0 0 0;
    }
  }

  &-button {
    background: #f109f3;
    width: 87px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: rgba(247, 247, 255, 1);
    margin: 0;
    padding: 0;
    border-radius: 1px;
    border: 0;
    outline: none;

    &[disabled] {
      background: #d5d5d5;
    }
  }
}

.complete {
  background: white;
  height: 148px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;

  &-icon {
    width: 68px;
    height: 68px;
    display: block;
    margin-bottom: 20px;
  }

  &-container {
    padding: 10px 0;
    background: white;
  }

  &-text {
    margin: 0;
    padding: 10px 15px 10px 20px;
    display: flex;
    justify-content: space-between;
  }
}

.button {
  &-exit {
    width: 265px;
    height: 48px;
    background: #f4f4f4;
    border-radius: 1px;
    border: 1px solid rgba(241, 9, 243, 1);
    color: #f109f3;
    margin-bottom: 12px;
    margin-top: 60px;
  }

  &-continue {
    margin-bottom: 12px;
    margin-top: 60px;
    width: 265px;
    height: 48px;
    background: linear-gradient(90deg, #267eff 0%, #215cfb 100%);
    border-radius: 1px;
    color: #f7f7ff;
    font-size: 16px;
    border: none;
  }
}

// input[type='radio'] {
//    -webkit-appearance: none;
// }
.alipay-copy {
  padding: 40px;
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: white;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
}


#input-name {
  width: 100%;
  box-sizing: border-box;
}
</style>
